import { render } from "./AfghanistanPage.vue?vue&type=template&id=15e3eb64&scoped=true"
import script from "./AfghanistanPage.vue?vue&type=script&lang=js"
export * from "./AfghanistanPage.vue?vue&type=script&lang=js"

import "./AfghanistanPage.vue?vue&type=style&index=0&id=15e3eb64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e3eb64"]])

export default __exports__